const { isArray, isPlainObject } = require('lodash');
// Converting Scala To JSON
const _convertScalaToJson = (scalaFormatStr = null) => {
  if (!scalaFormatStr || scalaFormatStr === 'Map()') return {};
  scalaFormatStr = scalaFormatStr
    .replaceAll('Map', '')
    .replaceAll(')', '}')
    .replaceAll('(', '{')
    .replaceAll('->', ':')
    .replace(`messages}`, `"messages"}`);
  return scalaFormatStr;
};

// Converting Json To Scala Recursively
const _convertJSONtoScala = (obj, payloadFieldName, needDataMessages = true) => {
  let scalaStr = _convertRecursiveJSONToScala(obj);

  if (needDataMessages) {
    //  adding "data" -> messages, in Map() or Map(..., )
    scalaStr = scalaStr.slice(0, -1); // removing last )
    scalaStr +=
      scalaStr === 'Map('
        ? `"${payloadFieldName || 'data'}" -> messages)`
        : `, "${payloadFieldName || 'data'}" -> messages)`;
  }
  return scalaStr;
};

const _convertRecursiveJSONToScala = (obj, isMap = true) => {
  let scalaStr = isMap ? `Map(` : `List(`;
  let innerObj = [];
  for (let key in obj) {
    if (
      typeof obj[key] === 'string' ||
      typeof obj[key] === 'number' ||
      typeof obj[key] === 'boolean'
    ) {
      innerObj.push(`"${key}" -> "${obj[key]}"`);
    } else if (isArray(obj[key])) {
      innerObj.push(`"${key}" -> ${_convertRecursiveJSONToScala(obj[key], false)}`);
    } else if (isPlainObject(obj[key])) {
      // object case
      innerObj.push(`"${key}" -> ${_convertRecursiveJSONToScala(obj[key], true)}`);
    }
  }
  scalaStr += `${innerObj.join(', ')})`;
  return scalaStr;
};

module.exports = {
  convertScalaToJson: _convertScalaToJson,
  convertJSONtoScala: _convertJSONtoScala,
};
